import React from 'react';
import {ListingImg, ListingImgContainer, ListingImgStyleProps} from '../../hooks/components/location/ListingImgStyles';

type ImageNotAvailablePlaceholderProps = ListingImgStyleProps;

const ImageNotAvailablePlaceholder = (props: ImageNotAvailablePlaceholderProps) => {
  return <ListingImgContainer {...props}>
    <ListingImg src={'/app-images/not-found-image/place_holder_image.png'}
                alt={'placeholder'}
                {...props}
    />
  </ListingImgContainer>
}

export default ImageNotAvailablePlaceholder;
